// extracted by mini-css-extract-plugin
module.exports = {"dialogAlerrtSuccessAdd":"DialogAlertSuccessAdd_dialogAlerrtSuccessAdd_vxe84","isStyleDingBeauty":"DialogAlertSuccessAdd_isStyleDingBeauty_46skr"};